import { RCEvent } from '../../types/coreEntites/Event';
import { BookingInstance } from '../../types/booking';
import {
	RCLeagueSeasonSignObject,
	RCLeague,
	RCLeagueSeason,
	RCSeasonDivisionStanding,
	SeasonPoolInstance,
	RCSeasonRound,
} from '../../types/coreEntites/Leagues';
import { auth } from 'lib/auth';
import { network } from 'lib/network';

const leagueApiUrl = `${process.env.BOND_SPORTS_API_URL}v1`;

async function getLeaguesByOrganizationId(organizationId: number): Promise<RCLeague[]> {
	const options = auth.getAuthHeaders();

	const leagues = await network.get(`${leagueApiUrl}/organizations/${organizationId}/leagues`, options);

	return leagues.data;
}

async function getLeagueById(leagueId: number): Promise<RCLeague> {
	const options = auth.getAuthHeaders();

	const league = await network.get(`${leagueApiUrl}/leagues/${leagueId}?datascope=full`, options);

	return league.data;
}

async function getLeagueSeasonById(leagueId: number, seasonId: number): Promise<RCLeagueSeason> {
	const options = auth.getAuthHeaders();

	const season = await network.get(`${leagueApiUrl}/leagues/${leagueId}/season/${seasonId}`, options);

	return season.data;
}

async function getLeagueSeasonStandings(leagueId: number, seasonId: number): Promise<RCSeasonDivisionStanding[]> {
	const options = auth.getAuthHeaders();

	const stadings = await network.get(`${leagueApiUrl}/leagues/${leagueId}/season/${seasonId}/standings`, options);

	return stadings.data;
}

async function getLeagueSeasonRounds(leagueId: number, seasonId: number, roundId: number): Promise<RCSeasonRound> {
	const options = auth.getAuthHeaders();

	const stadings = await network.get(
		`${leagueApiUrl}/leagues/${leagueId}/season/${seasonId}/rounds/${roundId}`,
		options
	);

	return stadings.data;
}

async function getLeagueSeasonMatches(leagueId: number, seasonId: number): Promise<RCEvent[]> {
	const options = auth.getAuthHeaders();

	const stadings = await network.get(`${leagueApiUrl}/leagues/${leagueId}/season/${seasonId}/matches`, options);

	return stadings.data;
}

async function signToLeagueSeason(
	leagueId: number,
	seasonId: number,
	options: RCLeagueSeasonSignObject
): Promise<SeasonPoolInstance | BookingInstance> {
	const signResponse = await network.post(
		`${leagueApiUrl}/leagues/${leagueId}/season/${seasonId}/sign`,
		network.addPlatformToBody(options)
	);
	return signResponse.data;
}

export const leagueApi = {
	getLeaguesByOrganizationId,
	getLeagueById,
	getLeagueSeasonById,
	getLeagueSeasonStandings,
	getLeagueSeasonMatches,
	signToLeagueSeason,
	getLeagueSeasonRounds,
};
